"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = void 0;
// This file is auto-generated by Lerna 'version' lifecycle script.
// Do not edit directly.
exports.version = '0.1.47';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmVyc2lvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy92ZXJzaW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLG1FQUFtRTtBQUNuRSx3QkFBd0I7QUFDWCxRQUFBLE9BQU8sR0FBRyxRQUFRLENBQUEifQ==